<template>
  <div class="form-out-view">
    <!-- //添加修改基本信息 -->
    <UserTitle title="添加基本信息"></UserTitle>
    <a-form :form="form" @submit="handleSubmit" class="form-all">
      <b-row>
        <a-form-item label="头像" class="all-input">
          <a-upload
            name="avatar"
            :headers="headers"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action="/api/fs/files"
            :before-upload="beforeUpload"
            @change="handleChangeAvatar"
          >
            <img
              class="all-upload-img"
              v-if="imageUrlAvatar"
              :src="getImgUrl(imageUrlAvatar)"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
            </div>
          </a-upload>
        </a-form-item>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="名称">
            <a-input
              v-decorator="[
                'realname',
                {
                  rules: [{ required: true, message: '请填写名称' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="婚姻状况">
            <a-select v-decorator="['marriageStatus']">
              <a-select-option value="已婚">已婚</a-select-option>
              <a-select-option value="未婚">未婚</a-select-option>
            </a-select>
          </a-form-item>
        </b-col>

        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="性别">
            <a-radio-group
              class="fluid-button"
              v-decorator="[
                'gender',
                {
                  rules: [{ required: true, message: '请选择性别' }]
                }
              ]"
            >
              <a-radio-button value="m">男</a-radio-button>
              <a-radio-button value="g">女</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="育儿状态">
            <a-select v-decorator="['children']">
              <a-select-option value="是">是</a-select-option>
              <a-select-option value="否">否</a-select-option>
            </a-select>
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="出生日期">
            <a-date-picker
              style="width:100%"
              v-decorator="[
                'birthday',
                {
                  rules: [{ required: true, message: '请选择出生日期' }]
                }
              ]"
              placeholder="请选择出生日期"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="最高学历">
            <a-select v-decorator="['education']">
              <a-select-option value="高中以下">高中以下</a-select-option>
              <a-select-option value="大专">大专</a-select-option>
              <a-select-option value="本科">本科</a-select-option>
              <a-select-option value="硕士">硕士</a-select-option>
              <a-select-option value="博士">博士</a-select-option>
            </a-select>
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="常住地">
            <a-cascader
              v-decorator="[
                'area',
                {
                  rules: [{ required: true, message: '请选择常住地' }]
                }
              ]"
              :options="options"
              placeholder="请选择常住地"
              :field-names="{
                label: 'name',
                value: 'code',
                children: 'children'
              }"
              :changeOnSelect="true"
              @change="onChange"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="最高学历专业">
            <a-input v-decorator="['major']" />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="政治面貌">
            <a-input v-decorator="['politicsStatus']" />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="邮箱">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    { required: true, message: '请填写邮箱' },
                    {
                      type: 'email',
                      message: '请确认邮箱格式是否正确'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <a-form-item label="个人优势" class="all-input">
          <a-textarea
            v-decorator="['advantage']"
            placeholder="请输入个人优势"
            :rows="6"
            allowClear
            :maxLength="120"
          />
        </a-form-item>
        <a-form-item label="证件照/身份证正面照" class="all-input">
          <a-upload
            name="avatar"
            :headers="headers"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action="/api/fs/files"
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <img
              class="all-upload-img"
              v-if="imageUrl"
              :src="getImgUrl(imageUrl)"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="证件照/身份证反面照" class="all-input">
          <a-upload
            name="avatar"
            :headers="headers"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action="/api/fs/files"
            :before-upload="beforeUpload"
            @change="handleChanges"
          >
            <img
              class="all-upload-img"
              v-if="imageUrls"
              :src="getImgUrl(imageUrls)"
            />
            <div v-else>
              <a-icon :type="loadings ? 'loading' : 'plus'" />
            </div>
          </a-upload>
        </a-form-item>
      </b-row>

      <a-form-item class="form-footer">
        <a-button class="success-button usually-button" html-type="submit"
          >保存</a-button
        >
        <a-button class="disable-button usually-button" @click="goBack"
          >取消</a-button
        >
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      areaDefaultValue: [],
      headers: {},
      options: [],
      imageUrlAvatar: "",
      imageUrl: "",
      imageUrls: "",
      loadingAvatar: "",
      loadings: false,
      loading: false,
      form: this.$form.createForm(this, {
        name: "basicForm"
      }),
      sexOption: [
        {
          text: "男",
          value: 0
        },
        {
          text: "女",
          value: 1
        }
      ]
    };
  },
  mounted() {
    this.getUser();
    this.getArea();
    const user = JSON.parse(localStorage.getItem("token"));
    let header =
      user && user.accessToken
        ? {
            authorization: user.tokenType + " " + user.accessToken
          }
        : {};
    this.headers = header;
  },
  methods: {
    //获取用户详细信息并赋值
    async getUser() {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        if (token && token.accessToken) {
          const data = await Api.User.getUser();
          let areaArr = [];
          if (data) {
            if (
              (data.info.provinceCode &&
                data.info.cityCode &&
                data.info.districtCode) !== ""
            ) {
              areaArr[0] = data.info.provinceCode;
              areaArr[1] = data.info.cityCode;
              areaArr[2] = data.info.districtCode;
            } else if (
              (data.info.provinceCode && data.info.cityCode) !== "" &&
              data.info.districtCode == ""
            ) {
              areaArr[0] = data.info.provinceCode;
              areaArr[1] = data.info.cityCode;
            } else if (
              data.info.provinceCode !== "" &&
              (data.info.districtCode && data.info.cityCode) == ""
            ) {
              areaArr[0] = data.info.provinceCode;
            } else if (
              (data.info.provinceCode &&
                data.info.cityCode &&
                data.info.districtCode) == ""
            ) {
              areaArr = [];
            }
            this.areaDefaultValue = areaArr;
            this.imageUrlAvatar = data.avatar !== "" ? data.avatar : "";
            this.imageUrl =
              data.info.idCardFront !== "" ? data.info.idCardFront : "";
            this.imageUrls =
              data.info.idCardBack !== "" ? data.info.idCardBack : "";
            this.$nextTick(() => {
              this.form.setFieldsValue({
                area: this.areaDefaultValue || [],
                realname: data.info.realname || "",
                marriageStatus: data.info.marriageStatus || "",
                gender: data.info.gender || "",
                children: data.info.children || "",
                birthday:
                  data.info.birthday && data.info.birthday !== ""
                    ? this.$moment(data.info.birthday)
                    : null,
                education: data.info.education || "",
                major: data.info.major || "",
                politicsStatus: data.info.politicsStatus || "",
                email: data.info.email || "",
                advantage: data.info.advantage || ""
              });
            });
          }
        } else {
          this.$router.push({
            path: "/login",
            query: { redirect: location.href }
          });
          this.$message.error("请先登录");
          this.user = {};
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    //处理地区
    onChange(value) {
      this.areaDefaultValue = value;
    },
    //保存
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        let data = {
          avatar: this.imageUrlAvatar,
          info: {
            realname: values.realname || "",
            marriageStatus: values.marriageStatus || "",
            gender: values.gender || "",
            children: values.children || "",
            birthday: this.$moment(values.birthday) || null,
            education: values.education || "",
            major: values.major || "",
            politicsStatus: values.politicsStatus || "",
            email: values.email || "",
            advantage: values.advantage || "",
            provinceCode: this.areaDefaultValue[0] || "",
            cityCode: this.areaDefaultValue[1] || "",
            districtCode: this.areaDefaultValue[2] || "",
            idCardFront: this.imageUrl,
            idCardBack: this.imageUrls
          }
        };
        if (!err) {
          const edit = await Api.User.EditUser(data);
          if (edit) {
            this.$message.success("修改成功");
            this.goBack();
          }
        }
      });
    },
    //上传
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          if (imageUrl) {
            this.imageUrl = this.uploadChange(info.file);
            this.loading = false;
          }
        });
      }
    },
    handleChanges(info) {
      if (info.file.status === "uploading") {
        this.loadings = true;
        return;
      }
      if (info.file.status === "done" && info.file.response) {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          if (imageUrl) {
            this.imageUrls = this.uploadChange(info.file);
            this.loadings = false;
          }
        });
      }
    },
    handleChangeAvatar(info) {
      if (info.file.status === "uploading") {
        this.loadingAvatar = true;
        return;
      }
      if (info.file.status === "done" && info.file.response) {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          if (imageUrl) {
            this.imageUrlAvatar = this.uploadChange(info.file);
            this.loadingAvatar = false;
          }
        });
      }
    },
    //上传之前
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("你只能上传jpg或者png图片");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过2MB");
      }
      return isJpgOrPng && isLt2M;
    },
    goBack() {
      this.$router.go(-1);
    },
    async getArea() {
      try {
        const data = await Api.Area.getArea();
        this.options = data.areas;
      } catch (e) {
        this.$message.error(e);
      }
    },
    //处理上传图片
    uploadChange(data) {
      if (data) {
        let ossBucket = data.response.data.files[0].ossBucket;
        let ossPath = data.response.data.files[0].ossPath;
        return `oss://${ossBucket}:${ossPath}`;
      } else {
        return "";
      }
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    }
  }
};
</script>
<style scoped></style>
